import * as React from 'react';
import { cn } from '../lib/utils';

export type FileInputProps = React.InputHTMLAttributes<HTMLInputElement>;

const FileInput = React.forwardRef<HTMLInputElement, FileInputProps>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      type="file"
      className={cn(
        'block w-full type-body-sm text-foreground file:mr-3 file:cursor-pointer file:rounded-md file:border file:border-input file:bg-background file:px-control-x-sm file:py-control-y-sm file:type-body-sm file:font-semibold',
        className,
      )}
      {...props}
    />
  ),
);

FileInput.displayName = 'FileInput';

export { FileInput };
